import AddModal, { type IAddModalProps } from "@/components/AddModal/index.jsx";
import { UseAddRoute } from "@/components/AddRoute/index.jsx";
import { ROUTE_OPTIONS } from "@/const.js";
import { hooks } from "@/store.js";
import { useModal } from "@ebay/nice-modal-react";
import { Fragment, memo } from "react";
import isEqual from "react-fast-compare";

function Route({ id }: { id: string; date: string }) {
	const record = hooks.useEventsUnsuspended(id);

	const addRouteModal = UseAddRoute();

	const planId = record.data?.get("planId");
	const date = record.data?.get("date");
	const route = record.data?.get("route");
	const routeArray = [
		...(record.data?.get("routeArray").map((i) => i.getAll()) || []),
	] as string[][];

	const routeInfo = routeArray.find((n) => n[0] === route);
	const routeConfig = ROUTE_OPTIONS.find((n) => n.value === route);

	return (
		<div
			className="flex items-center  "
			onClick={() => {
				addRouteModal.show({
					planId,
					date,
					mode: "select",
					id,
					defaultValue: routeArray,
					selectKey: route,
				});
			}}
		>
			<div
				className={
					"w-12  flex shrink-0 justify-center items-center rounded-[14px] bg-cover bg-center "
				}
			>
				<i
					className={`ic-outline text-gray-400/80  leading-none  text-sm ${
						routeConfig?.icon ? `md-${routeConfig?.icon}` : "md-hourglass_empty"
					}  `}
				/>
			</div>
			<div className="text-sm font-semibold flex items-center text-gray-400/80 ml-[18px] flex-grow">
				{routeConfig === undefined && "未选择"}
				{routeInfo?.map((i, index, array) => {
					if (index === 0 || index === 3) return "";
					if (index === 1 && array[2]) {
						return (
							<Fragment key={`${index + i}`}>
								{i}
								<span className="mx-2">|</span>
							</Fragment>
						);
					}
					return i;
				})}
				<i className="ic-round md-keyboard_arrow_down ml-1" />
			</div>
		</div>
	);
}

export default memo(Route, isEqual);
